<template>
    <div>
        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoPesquisaAlertaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="value">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ value && value.id_pesquisa_alerta ? '' : 'Novo' }}
                            Filtro
                            <span class="badge badge-secondary" v-if="value && value.id_pesquisa_alerta">
                                #{{ value.id_pesquisa_alerta }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="value">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="value.st_titulo" />
                            </div>
                            <!-- { id: 'documentoAtendimento', search: 'Consultório (Formulário Barra)' }, -->
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Origem"
                                    :validate="validate"
                                    required
                                    type="select"
                                    :optionsList="[
                                        { id: 'anamnese', search: 'Consultório' },
                                        { id: 'laudo', search: 'Laudo' },
                                        { id: 'registro', search: 'Assistência (Consolidado)' },
                                        { id: 'registro-ind', search: 'Assistência (Individualizado)' },
                                        { id: 'preatend', search: 'Formulário de Pré-Atendimento' },
                                        { id: 'docatend', search: 'Formulário (Barra) de Atendimento' },
                                    ]"
                                    optionsData="id"
                                    v-model="value.st_origem" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Sexo"
                                    :validate="validate"
                                    type="select"
                                    :optionsList="[
                                        { id: 'A', search: 'Ambos' },
                                        { id: 'M', search: 'Masculino' },
                                        { id: 'F', search: 'Feminino' },
                                    ]"
                                    optionsData="id"
                                    v-model="value.ch_sexo" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Idade Mínima"
                                    :validate="validate"
                                    type="number"
                                    v-model="value.in_idade_minima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Idade Máxima"
                                    :validate="validate"
                                    type="number"
                                    v-model="value.in_idade_maxima" />
                            </div>
                        </div>

                        <div class="form-row" v-if="1==1 || value.st_origem == 'registro'">
                            <div class="col col-12">
                                <az-input
                                    label="Formulário"
                                    type="autocomplete"
                                    placeholder="Selecione o Modelo..."
                                    optionsMode="aql"
                                    service="modelos.index"
                                    :optionsParm="{
                                        mode: 'selecao', 
                                        pesquisaclinica: true
                                    }"
                                    optionsData="id_modelo_prontuario"
                                    v-model="value.id_modelo_prontuario">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="value.id_modelo_prontuario">
                                            <span class="input-group-text">
                                                #{{ value.id_modelo_prontuario}}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <az-sub-title title="Regras" class="mt-3">
                            <a href="#" @click.prevent="incluir_regra(value)" class="card-link">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                Incluir Regra
                            </a>
                        </az-sub-title>
                        <template v-if="value.js_regra">
                            <div class="form-row" v-for="(regra, irx) in value.js_regra" :key="irx">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        :label="irx ? '' : 'Id'"
                                        required
                                        :validate="validate"
                                        v-model="regra.id">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_regra(value, irx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        :label="irx ? '' : 'Tipo'"
                                        type="select"
                                        :optionsList="[
                                            { id: 'text', search: 'Texto' },
                                            { id: 'number', search: 'Número' },
                                            { id: 'checkbox', search: 'Verdadeiro/Falso' },
                                            { id: 'sv', search: 'Pontos Score' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="regra.type" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        :label="irx ? '' : 'Operador'"
                                        type="select"
                                        :optionsList="[
                                            { id: '=', search: 'Igual' },
                                            { id: '<>', search: 'Diferente' },
                                            { id: '>', search: 'Maior que' },
                                            { id: '>=', search: 'Maior/Igual a' },
                                            { id: '<', search: 'Menor que' },
                                            { id: '<=', search: 'Menor/Igual a' },
                                            { id: 'in', search: 'Lista' },
                                            { id: 'nin', search: 'Fora da lista' },
                                            { id: 'likes', search: 'Começar com' },
                                            { id: 'nlikes', search: 'Não Começar com' },
                                            { id: 'like', search: 'Contém' },
                                            { id: 'nlike', search: 'Não Contém' },
                                            { id: 'is-not-null', search: 'Com Valor' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :edicao="regra.type != 'checkbox'"
                                        :validate="validate"
                                        v-model="regra.oper" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="regra.oper != 'is-not-null'">
                                    <az-input
                                        v-if="regra.type == 'checkbox'"
                                        sizing="sm"
                                        :label="irx ? '' : 'Valor'"
                                        :validate="validate"
                                        type="checkbox"
                                        v-model="regra.value" />

                                    <az-input
                                        v-else
                                        sizing="sm"
                                        :label="irx ? '' : 'Valor'"
                                        required
                                        :validate="validate"
                                        v-model="regra.value" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="regra.type == 'checkbox'">
                                    <az-input   
                                        sizing="sm"
                                        :label="irx ? '' : 'Grupo'"
                                        :validate="validate"
                                        v-model="regra.group" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="false">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox"
                                        :label="irx ? '' : 'Obrigatório'"
                                        :validate="validate"
                                        v-model="regra.required" />
                                </div>
                            </div>

                        </template>
                        <span v-if="!value.js_regra || !value.js_regra.length" class="text-muted">
                            Nenhuma
                        </span>

                        <!-- Exibição -->
                        <az-sub-title title="Exibir" class="mt-3">
                            <a href="#" @click.prevent="incluir_campo(value)" class="card-link">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                Incluir Campo
                            </a>
                        </az-sub-title>

                        <template v-if="value.js_campos && value.js_campos.length">
                            <div class="form-row" v-for="(campo, icx) in value.js_campos" :key="'C' + icx">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        :label="icx ? '' : 'Id'"
                                        sizing="sm"
                                        placeholder="Informe o Id do Campo..."
                                        required
                                        :validate="validate"
                                        v-model="campo.id">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_campo(value, icx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        :label="icx ? '' : 'Título'"
                                        sizing="sm"
                                        placeholder="Id..."
                                        :validate="validate"
                                        v-model="campo.titulo" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="icx ? '' : 'Tipo'"
                                        sizing="sm"
                                        placeholder="Tipo..."
                                        type="select"
                                        :optionsList="[
                                            { id: 'text', search: 'Texto' },
                                            { id: 'number', search: 'Número' },
                                            { id: 'date', search: 'Data' },
                                            { id: 'datetime', search: 'Data/Hora' },
                                            { id: 'checkbox', search: 'Verdadeiro/Falso' },
                                            { id: 'sv', search: 'Pontos Score' },
                                        ]"
                                        optionsData="id"
                                        :validate="validate"
                                        v-model="campo.type" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="icx ? '' : 'Ação'"
                                        sizing="sm"
                                        placeholder="Ação..."
                                        type="select"
                                        :optionsList="[
                                            { id: 'consolidar', search: 'Consolidar' },
                                        ]"
                                        optionsData="id"
                                        :validate="validate"
                                        v-model="campo.acao">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2" v-if="campo.acao == 'consolidar'">
                                    <az-input
                                        :label="icx ? '' : 'Estilo'"
                                        sizing="sm"
                                        placeholder="Estilo..."
                                        type="select"
                                        :optionsList="[
                                            { id: 'lista', search: 'Lista' },
                                            { id: 'pie', search: 'Gráfico Pizza' },
                                            { id: 'horizontalBar', search: 'Gráfico Barra Horizontal' },
                                            { id: 'bar', search: 'Gráfico Barra Vertical' },
                                        ]"
                                        optionsData="id"
                                        :validate="validate"
                                        v-model="campo.estilo">
                                    </az-input>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <span class="text-muted">
                                Campos definidos nas regras de busca.
                            </span>
                        </template>

                        <!-- Campos do Paciente -->
                        <template v-if="paciente_campos && paciente_campos.length">
                            <az-sub-title title="Campos do Cadastro do Paciente" class="mt-3">
                                <a href="#" @click.prevent="incluir_campo_paciente(value)" class="card-link">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                    Incluir Campo
                                </a>
                            </az-sub-title>

                            <template v-if="value.js_campos_paciente && value.js_campos_paciente.length">
                                <div class="form-row" v-for="(campo_paciente, igx) in value.js_campos_paciente" :key="'GR' + igx">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Campo..."
                                            type="select"
                                            :optionsList="paciente_campos"
                                            optionsData="id"
                                            optionsDisplay="search"
                                            required
                                            :validate="validate"
                                            v-model="campo_paciente.id">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_item(value.js_campos_paciente, igx)">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Título..."
                                            required
                                            :validate="validate"
                                            v-model="campo_paciente.titulo" />
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <span class="text-muted">
                                    Nenhum campo do paciente selecionado para exibição dos dados.
                                </span>
                            </template>

                        </template>

                        <!-- Gráficos -->
                        <az-sub-title title="Gráficos" class="mt-3">
                            <a href="#" @click.prevent="incluir_grafico(value)" class="card-link">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                Incluir Gráfico
                            </a>
                        </az-sub-title>

                        <template v-if="value.js_graficos && value.js_graficos.length">
                            <div class="form-row" v-for="(grafico, igx) in value.js_graficos" :key="'GR' + igx">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        :label="igx ? '' : 'Id ou Grupo'"
                                        sizing="sm"
                                        placeholder="Campo/Grupo..."
                                        required
                                        :validate="validate"
                                        v-model="grafico.id">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_grafico(value, igx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="igx ? '' : 'Título'"
                                        sizing="sm"
                                        placeholder="Título"
                                        required
                                        :validate="validate"
                                        v-model="grafico.titulo" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="igx ? '' : 'Estilo'"
                                        sizing="sm"
                                        placeholder="Estilo..."
                                        type="select"
                                        :optionsList="[
                                            { id: 'lista', search: 'Lista' },
                                            { id: 'pie', search: 'Gráfico Pizza' },
                                            { id: 'horizontalBar', search: 'Gráfico Barra Horizontal' },
                                            { id: 'bar', search: 'Gráfico Barra Vertical' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="grafico.estilo">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="igx ? '' : 'Quebra'"
                                        sizing="sm"
                                        placeholder="Sem quebra"
                                        type="select"
                                        :optionsList="[
                                            { id: 'unidade', search: 'Unidade' },
                                            { id: 'medico', search: 'Médico' },
                                            { id: 'procedimento', search: 'Procedimento' },
                                            { id: 'mes', search: 'Mês' },
                                        ]"
                                        optionsData="id"
                                        :validate="validate"
                                        v-model="grafico.quebra1" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="igx ? '' : 'Sub-Quebra'"
                                        sizing="sm"
                                        placeholder="Sem quebra"
                                        type="select"
                                        :optionsList="[
                                            { id: 'unidade', search: 'Unidade' },
                                            { id: 'medico', search: 'Médico' },
                                            { id: 'procedimento', search: 'Procedimento' },
                                            { id: 'mes', search: 'Mês' },
                                        ]"
                                        optionsData="id"
                                        :edicao="grafico.quebra1 ? true : false"
                                        :validate="validate"
                                        v-model="grafico.quebra2" />
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        :label="igx ? '' : 'Sintético'"
                                        :validate="validate"
                                        type="checkbox"
                                        :edicao="grafico.quebra1 ? true : false"
                                        v-model="grafico.sintetico" />
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <span class="text-muted">
                                Gráficos para exibição dos dados.
                            </span>
                        </template>

                        <!-- Filtros -->
                        <filtro-model class="mt-3" v-model="value.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        <br><br><br><br><br><br>

                        <template v-if="false">
                            <hr>
                            <pre>{{ value.js_regra }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="pesquisaAlerta" :id="value.id_pesquisa_alerta" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-outline-success" @click="buscar()" v-if="pesquisa">Buscar</button>
                        <az-submit @click="atualizar ()">{{ value.id_pesquisa_alerta ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import FiltroModel from '../../cadastros/shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            value: null, 
            validate: false, 
            paciente_campos: [], 
        };
    }, 

    props: ['pesquisa'],

    components: { 
        AzInput,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle,
        FiltroModel,
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                // {id:'App\\azure\\modeloProntuario', search:'Modelo de Prontuário', service: 'modelos.index', parms: { mode: 'selecao' }}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\recepcao', search:'Recepção',service:'recepcaos.index', parms: { filtros: true }},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }
            
            return _.orderBy(opcoes, 'search');
        },
    },

    methods: { 
        remover_item (lista, idx) { 
            if ( lista && lista.length ) { 
                lista.splice(idx, 1);
            }
        },

        incluir_campo_paciente () { 
            if ( !this.value.js_campos_paciente ) { 
                this.value.js_campos_paciente = [];
                this.$forceUpdate();
            }

            this.value.js_campos_paciente.push({
                id: '',
                titulo: '',
            });
        },

        remover_grafico (item, igx) { 
            item.js_graficos.splice(igx, 1);
        },

        remover_regra(item, irx) { 
            item.js_regra.splice(irx, 1);
        },

        remover_campo(item, irx) { 
            item.js_campos.splice(irx, 1);
        },

        incluir_regra(item) { 
            item.js_regra.push({
                id: '',
                type: 'text',
                oper: '=',
                value: '',
                required: true, 
            });
        },

        incluir_grafico(item) { 
            if ( !item.js_graficos ) { 
                item.js_graficos = [];
                this.$forceUpdate();
            }

            item.js_graficos.push({
                id: '',
                titulo: '',
                estilo: 'lista',
                quebra1: '', 
                quebra2: '',  
            });
        },

        incluir_campo(item) { 
            if ( !item.js_campos ) { 
                item.js_campos = [];
                this.$forceUpdate();
            }

            item.js_campos.push({
                id: '',
                type: '',
                acao: '', 
            });
        },

        incluir () { 
            this.validate = false;
            
            let item = {
                id_pesquisa_alerta: null, 
                st_titulo: "", 
                fl_ativo: true,
                fl_regra_livre: false,
                fl_notificacao: false,
                js_regra: [],
                js_campos: [], 
                js_campos_paciente: [], 
                js_notificacao: [],
                js_graficos: [], 
                filtros: [], 
                ch_sexo: 'A',
                in_idade_minima: 0,
                in_idade_maxima: 999, 
                st_origem: 'anamnese',
            };

            this.editar (item);
        },

        editar (item) { 
            this.validate = false;
            this.value = null;

            this.$nextTick(() => { 
                this.value = _.cloneDeep (item);
        
                $('#edicaoPesquisaAlertaModal').modal('show');
            });
        },

        buscar () { 
            if ( !this.value.st_titulo ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Necessário definir o título.",
                    life: 3000
                });
                return;
            }

            this.value.search = this.value.st_titulo + ' (Editado)';
            this.value.editado = true;
            this.$emit('refresh', this.value);

            $('#edicaoPesquisaAlertaModal').modal('hide');
        },

        atualizar () { 
            this.value.search = this.value.st_titulo;
            this.value.editado = false;

            this.$util.atualizar(this, { 
                service: 'pesquisa_alertas',
                dados: this.value,
                modal: 'edicaoPesquisaAlertaModal',
                callback: res => { 
                    this.value.id_pesquisa_alerta = res.id_pesquisa_alerta;
                    this.$emit('refresh', this.value);
                }
            });
        },
    },

    mounted() { 

        this.$util.loadItem(this, {
            service: 'etiquetas',
            func: 'campos',
            parms: {
                model: 'pessoa'
            }
        })
        .then(res => {
            this.paciente_campos = res;
        });

    }
}
</script>